export const DOCUMENT_TYPE_MAP = {
    passport: 'PASSPORT',
    id: 'ID_CARD',
    driving: 'DRIVING_LICENSE',
    utilityBill: 'UB',
    other: 'DOC'
};

export const ADDITIONAL_UB_STEP_REQUIRED_FOR = [
    'passport',
    'id'
];

export const JUMIO_POPUP_IFRAME_MOBILE_HEIGHT = '30';
export const JUMIO_POPUP_IFRAME_DESKTOP_HEIGHT = '40';
export const JUMIO_POPUP_IFRAME_TYPE_HEIGHT = 'rem';

export const JUMIO_STEPS = {
    start: 'start',
    loading: 'loading',
    takeMeHome: 'takeMeHome',
    error: 'error',
    passed: 'passed',
    utilityBill: 'utilityBill'
};
